import React, { useEffect, useRef, useState } from 'react';

const NUMBER = /-?\d+(?:[.,]\d+)?/;
const DURATION_MS = 750;
const easeOut = (t: number) => 1 - Math.pow(1 - t, 3);

// Un valor como "15.5°", "73%" o "1011" que, al aparecer o cambiar, cuenta
// hasta su número en vez de saltar. El texto alrededor queda igual. Con
// "reducir movimiento" (o si no hay número) se muestra directo.
const CountUp: React.FC<{ value: string }> = ({ value }) => {
  const match = value.match(NUMBER);
  const target = match ? Number(match[0].replace(',', '.')) : null;
  const decimals = match && /[.,](\d+)/.test(match[0]) ? match[0].split(/[.,]/)[1].length : 0;
  const [shown, setShown] = useState(target);
  const from = useRef(0);

  useEffect(() => {
    if (target === null) return;
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      setShown(target);
      return;
    }
    const start = performance.now();
    const origin = from.current;
    let frame = 0;
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / DURATION_MS);
      setShown(origin + (target - origin) * easeOut(t));
      if (t < 1) frame = requestAnimationFrame(tick);
      else from.current = target;
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target]);

  if (!match || target === null || shown === null) return <>{value}</>;
  const text = shown.toFixed(decimals).replace('.', match[0].includes(',') ? ',' : '.');
  return (
    <span className="count-up">
      {value.slice(0, match.index)}
      {text}
      {value.slice((match.index ?? 0) + match[0].length)}
    </span>
  );
};

export default CountUp;
